var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    {
      staticClass:
        "d-flex flex-row-reverse cursor p-0 align-items-center justify-content-center list-style-none",
    },
    [
      _vm.displayNextPage && _vm.displayLastPage
        ? _c(
            "li",
            {
              staticClass: "p-2 pagination-button cursor",
              on: {
                click: function ($event) {
                  return _vm.pagination(_vm.allPages)
                },
              },
            },
            [_c("i", { staticClass: "fa-solid fa-chevrons-right" })]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.displayNextPage
        ? _c(
            "li",
            {
              staticClass: "p-2 pagination-button cursor",
              on: {
                click: function ($event) {
                  return _vm.pagination(_vm.currentPage + 1)
                },
              },
            },
            [_c("i", { staticClass: "fa-solid fa-chevron-right" })]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.displayNextPage || _vm.displayPreviousPage
        ? _c(
            "li",
            { staticClass: "p-2 cursor" },
            [
              _vm._l(_vm.previousPages, function (previousPage) {
                return _c(
                  "span",
                  {
                    key: previousPage,
                    staticClass: "px-3 py-2 pagination-button",
                    on: {
                      click: function ($event) {
                        return _vm.pagination(previousPage)
                      },
                    },
                  },
                  [_vm._v(_vm._s(previousPage))]
                )
              }),
              _vm._v(" "),
              _c("span", { staticClass: "pagination-button-active" }, [
                _vm._v("\n        " + _vm._s(_vm.currentPage) + "\n    "),
              ]),
              _vm._v(" "),
              _vm._l(_vm.nextPages, function (nextPage) {
                return _c(
                  "span",
                  {
                    key: nextPage + _vm.currentPage,
                    staticClass: "px-3 py-2 pagination-button",
                    on: {
                      click: function ($event) {
                        return _vm.pagination(nextPage + _vm.currentPage)
                      },
                    },
                  },
                  [_vm._v(_vm._s(nextPage + _vm.currentPage))]
                )
              }),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.displayPreviousPage
        ? _c(
            "li",
            {
              staticClass: "p-2 pagination-button cursor",
              on: {
                click: function ($event) {
                  return _vm.pagination(_vm.currentPage - 1)
                },
              },
            },
            [_c("i", { staticClass: "fa-solid fa-chevron-left" })]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.displayPreviousPage && _vm.displayFirstPage
        ? _c(
            "li",
            {
              staticClass: "p-2 pagination-button cursor",
              on: {
                click: function ($event) {
                  return _vm.pagination(1)
                },
              },
            },
            [_c("i", { staticClass: "fa-solid fa-chevrons-left" })]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }